
const mainProjects = [
        {
            "id": 1,
            "number": "01",
            "name": "성보문화재보존관리시스템",
            "link": "https://bmuseum.or.kr/#none",
            "date": "2022"
        },
        {
            "id": 2,
            "number": "02",
            "name": "강동미즈여성병원",
            "link": "http://gdmiz.com/",
            "date": "2022"
        },
        {
            "id": 3,
            "number": "03",
            "name": "웹쟁이",
            "link": "https://www.webjangi.com/",
            "imgUrl": "/portfolio/assets/images/thum/p3.jpg",
            "date": "2022"
        },
        {
            "id": 4,
            "number": "04",
            "name": "LG U⁺ 차량관제",
            "link": "https://car.uplus.co.kr/security/login",
            "date": "2021"
        }
] 
    

export default mainProjects;